import { GET, PUT } from '../request'

export const getCajas = ({ mes, centro }) =>
  GET('/api/core/contabilidad/caja/list', { mes, centro })

export const updateCaja = ({
  id,
  balance_inicial,
  balance_final_real,
  hora_apertura,
  hora_cierre,
  estado
}) =>
  PUT('/api/core/contabilidad/caja/update', {
    id,
    balance_inicial,
    balance_final_real,
    hora_apertura,
    hora_cierre,
    estado
  })
